// extracted by mini-css-extract-plugin
export default {"layout":"Chat_layout__z22-u","body":"Chat_body__2W71p","sidebar":"Chat_sidebar__vR5Rw"};